import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import {
	setPerformanceMarkLoadStart,
	setPerformanceMarkLoadEnd,
} from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/performance-marks/index.tsx';
import type ServicedeskSidebarType from './ui/index.tsx';
/**
 * LazyForPaintServicedeskSidebar is isolated in a separate file to ensure proper handling by webpack's null-loader.
 *
 * This file is explicitly excluded in:
 * - jira/services/jira-ssr/apps/webpack.config.js
 * via the exclude pattern: /src\/packages\/navigation-apps\/sidebar\/servicedesk\/src\/async-for-paint.tsx/
 *
 * Without this separation, webpack's null-loader would either nullify the forPaint component (if the file
 * isn't excluded) or preserve unwanted components (if the whole file is excluded), leading to runtime errors
 * when trying to use nullified components with React.memo().
 */
export const LazyForPaintServicedeskSidebar = lazyForPaint<typeof ServicedeskSidebarType>(
	() => {
		setPerformanceMarkLoadStart();

		return import(/* webpackChunkName: "async-sidebar-servicedesk" */ './index').then((bundle) => {
			setPerformanceMarkLoadEnd();
			return bundle;
		});
	},
	{ entryFsSsrLiftImportToModule: false },
);
